import { SHOW_LOADER, HIDE_LOADER } from '../types/loader.types'

export const showLoader = (message) => ({ type: SHOW_LOADER, payload: message })
export const hideLoader = () => ({ type: HIDE_LOADER })
